const Theme = {
  SIZES: {
    ICON_SMALL: 16,
    ICON_MEDIUM: 20,
    ICON_LARGE: 24,
  },
  STYLES: {
    GRADIENT_TEXT: {
      backgroundClip: "text",
      backgroundImage: "linear-gradient(to right, #38B2AC, #4299E1)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      fontWeight: "bold",
    },
    DARK_BG_BUTTON: "#111927",
    CUCUMBER_WATER: "#E6FFFA",
  },
};

export default Theme;
